<template>
  <div class="min-h-screen bg-[#F7F7F7] flex flex-col items-center py-12 px-4 sm:px-6 lg:px-8">
    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 w-full max-w-screen-xl">
      <div
          v-for="(folder, index) in folders"
          :key="index"
          class="relative group overflow-hidden rounded-lg shadow-lg cursor-pointer"
          @click="navigateToGallery(folder.link)"
      >
        <img
            :src="folder.images[0].src"
            :alt="folder.images[0].alt"
            class="w-full h-[300px] object-cover transition duration-300 group-hover:scale-105 group-hover:brightness-110"
            @error="handleImageError(folder.images[0])"
        />
        <div
            class="absolute inset-0 bg-black bg-opacity-50 hover:bg-opacity-0 transition-all duration-300 flex items-center justify-center text-white text-lg font-bold"
        >
          {{ folder.title.pl }}
        </div>
        <button
            class="absolute bottom-4 left-1/2 transform -translate-x-1/2 bg-[#2E2E2E] bg-opacity-60 text-white text-medium text-lg px-2 py-2 rounded-lg shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
          Zobacz więcej
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { galleryFolders } from '@/data/GalleryPage/text.ts';

export default {
  data() {
    return {
      folders: [], // Tablica do przechowywania folderów
      link: '',
    };
  },
  created() {
    this.loadGalleryImages();
  },
  methods: {
    loadGalleryImages() {
      // Przekształcamy dane z galleryFolders na strukturę odpowiednią do wyświetlania
      this.folders = Object.keys(galleryFolders).map(folderKey => {
        const folderData = galleryFolders[folderKey];
        const folderImages = [{
          src: `images/gallery/${folderKey}/image1.jpeg`,
          alt: `${folderData.title} - Zdjęcie 1`,
          fallback: `images/gallery/${folderKey}/image1.jpg`
        }];
        return {
          name: folderKey,
          title: folderData.title,
          images: folderImages,
          link: folderData.link
        };
      });
    },
    handleImageError(image) {
      if (image.src !== image.fallback) {
        image.src = image.fallback;
      }
    },
    navigateToGallery(folderName) {
      this.$router.push({path: `/galeria/${folderName}`});
    }
  }
};
</script>
